module.exports = __webpack_public_path__ + "img/zurich.7de55648.png";